/**
 * Narrows `T | undefined` to `T`.
 * E.g. useful as a hint for TS to infer data type after `filter(isDefined)`
 */
export function isDefined<T>(value: T | undefined): value is T {
  return value !== undefined;
}
